// LEGACY - please don't use this component
// @ts-nocheck

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import TableSortIcon from '../TableSortIcon/TableSortIcon'
import { Icon } from '../Icon'
import { ProfilePicture } from '../ProfilePicture'
import { colors } from '@lmc/common/constants'
import _ from 'lodash'

/**
 * @deprecated
 */
export default class Table extends Component<any, any> {
  state = {
    sortedColumn: {
      columnTitle: this.props.defaultSorted
        ? this.props.defaultSorted.title
        : undefined,
      sorted: this.props.defaultSorted
        ? this.props.defaultSorted.sorted
        : undefined,
    },
  }

  handleSortChange = (newSort, columns) => {
    // Takes a newSort prop and sets the direction based
    // on its .desc prop. The sortedColumn object in state
    // is set on the basis of which column is being sorted.
    const direction = newSort.desc ? 'desc' : 'asc'

    this.setState({
      sortedColumn: {
        columnTitle: newSort.id,
        sorted: direction,
      },
    })

    // This checks whether a sort has happened, and if it has,
    // it returns a sort key object. The object has two props:
    //  a key, which uses _.find to get the key for the column
    //  being sorted, and order, which indicates the direction
    //  that the column is being sorted.
    if (this.props.onSortChange) {
      this.props.onSortChange({
        key: _.find(columns, ['label', newSort.id]).key,
        order: direction,
      })
    }
  }

  renderHeader = (column) => {
    let containerStyles = {
      ...styles.header,
      ...column.headerStyle,
    }

    if (column.type === 'percentage' || column.type === 'number') {
      containerStyles = {
        ...containerStyles,
        ...styles.rightAlign,
      }
    }

    return (
      <div>
        <div style={containerStyles}>
          {/* Checks whether an icon exists for a given header. If it 
                    does, the icon is rendered. If not, it's set to null. */}
          {column.icon ? (
            <Icon
              name={column.icon.name}
              fill={column.icon.color}
              size={column.icon.size}
              viewBox={column.icon.viewBox}
              style={{ ...styles.icon, marginTop: column.icon.marginTop }}
            />
          ) : null}
          <div>{column.label}</div>
          {column.sortable ? (
            <TableSortIcon
              ascending={
                column.label === this.state.sortedColumn.columnTitle &&
                this.state.sortedColumn.sorted === 'asc'
              }
              descending={
                column.label === this.state.sortedColumn.columnTitle &&
                this.state.sortedColumn.sorted === 'desc'
              }
              paddingLeft={2}
            />
          ) : null}
        </div>
        {column.isWrapped ? <div>Test</div> : null}
      </div>
    )
  }

  renderCell = (row, index, type) => {
    const original = row.original[index]
    let value

    typeof original === 'object' ? (value = original.value) : (value = original)

    if (type === 'profile') {
      return (
        <div>
          <div style={styles.profilePictureContainer}>
            <ProfilePicture
              type="small"
              url={original.picture}
              style={styles.profilePicture}
            />
          </div>
          <div
            style={{
              paddingLeft: '10px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {value}
          </div>
        </div>
      )
    }

    if (type === 'symptoms') {
      return (
        <div style={styles.symptomsContainer}>
          {original && (
            <div>
              {original.symptoms.map((entry, i) => {
                const isNotLast = i < original.symptoms.length - 1
                return (
                  <div key={entry.symptom}>
                    <div style={{ paddingRight: 5, float: 'left' }}>
                      {entry.symptom}
                      {isNotLast && ','}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
          {original && original.alertIconStyle && (
            <Icon
              name={original.alertIconStyle.name}
              fill={original.alertIconStyle.color}
              style={styles.icon}
            />
          )}
        </div>
      )
    }

    if (type === 'alert') {
      return (
        <div>
          <div style={{ paddingRight: 5, float: 'left' }}>{value}</div>
          {original.displayAlert ? (
            <Icon
              name={original.alertIconStyle.name}
              fill={original.alertIconStyle.color}
              size={original.alertIconStyle.size}
              viewBox={original.alertIconStyle.viewBox}
              style={{
                ...styles.icon,
                marginTop: original.alertIconStyle.marginTop,
              }}
            />
          ) : null}
        </div>
      )
    }

    if (type === 'percentage') {
      return (
        <div style={styles.number}>
          <span style={row.value === 0 ? styles.zeroValue : null}>
            {row.value}%<span style={styles.absoluteValue}> ({value})</span>
          </span>
        </div>
      )
    }
    if (type === 'number') {
      return (
        <div style={styles.number}>
          <span style={row.value === 0 ? styles.zeroValue : null}>
            {row.value}
          </span>
        </div>
      )
    }
    return <span paddingLeft={0}>{row.value}</span>
  }

  // Determines what value is used to sort the row
  rowAccessor(row, index, type) {
    const value = row[index]

    if (type === 'percentage') {
      const sum = _.chain(row).filter(_.isNumber).sum().value()
      return Math.floor((100 * value) / sum) || 0
    }

    if (
      type === 'profile' ||
      type === 'alert' ||
      (type === 'symptoms' && row[index])
    ) {
      return row[index].value
    }

    return row[index]
  }

  render() {
    const { data, columns, className } = this.props

    const cols = columns.map((column, index) => {
      // Checks whether or not the column has a sortable property.
      // If it does, column.sortable is kept as column.sortable.
      // If it doesn't, the default is set to true. In other words,
      // unless explicitly stated otherwise, a column will be sortable.
      column.sortable = column.hasOwnProperty('sortable')
        ? column.sortable
        : true

      return {
        id: column.label,
        Header: () => this.renderHeader(column),
        accessor: (row) => this.rowAccessor(row, index, column.type),
        Cell: (row) => this.renderCell(row, index, column.type),
        ...column,
      }
    })

    return (
      <ReactTable
        data={data}
        style={styles.table}
        pageSize={data.length}
        // defaultSorted={[{ id: '_title' }]}
        columns={cols}
        showPagination={false}
        minRows={0}
        onSortedChange={(sorts) =>
          this.handleSortChange(sorts[0], this.props.columns)
        }
        className={className}
      />
    )
  }
}

Table.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.array,
  data: PropTypes.array,
  defaultSorted: PropTypes.object,
  onSortChange: PropTypes.func,
}

const styles = {
  absoluteValue: {
    color: colors.darkgrey,
  },
  cell: {},
  header: {
    padding: 0,
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
  },
  rightAlign: {
    float: 'right',
  },
  icon: {
    flexShrink: 0,
    marginRight: 5,
    top: -2,
    position: 'relative',
  },
  number: {
    textAlign: 'right',
  },
  profilePicture: {
    float: 'left',
  },
  profileNameContainer: {
    paddingLeft: '10px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  profilePictureContainer: {
    marginTop: '-8px',
    paddingBottom: '7px',
  },
  symptomsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  table: {
    borderRight: '0px',
    borderLeft: '0px',
    borderTop: '0px',
  },
  zeroValue: {
    opacity: 0.4,
    textAlign: 'right',
  },
}
